import { useQuery } from 'react-query';
import { getAllCategories, getAllProductsByAccountId, getProductByFirestoreId } from '../sp-firebase/productFB';
import { StatusType } from '../sp-types/statusType';

export const useProductCategories = () => {
  const fetchFunction = () => getAllCategories();
  return useQuery('product-categories', fetchFunction);
};

export const useAllProducts = (accountId?: string, statusTypes: StatusType[] = ['completed']) => {
  const enable = accountId !== undefined;
  const fetchFunction = () => getAllProductsByAccountId(accountId || '', statusTypes);
  return useQuery('account-products', fetchFunction, { enabled: enable });
};

export const useProduct = (productId?: string) => {
  const enable = productId !== undefined && productId !== '';
  const fetchFunction = () => getProductByFirestoreId(productId || '');
  return useQuery('product', fetchFunction, { enabled: enable });
};
